import { store } from "@root/store/index";
import { querySaveWatchRecord } from "./service";
import { setVideoInfo } from "@root/reducers/video";
import Md5 from "md5";
import { log } from "console";
// 传入参数
// @initVideoFn
class videoControlClass {
  public count: number = this.getNumber();
  private ccVideoUrl = `https://yth.mvwchina.com/cc/videourl`; // cc的video接口
  private API_KEY = "Y7gxBFDbz5yBU36vDXCv0RbIjyykV5Dt";
  private userId = "D71B0368E20B4CF5"; // 用户id
  // 获取当前随机次数
  getNumber(): number {
    const { videoInfo } = store.getState();
    const { randomPopUpNum = 0 } = videoInfo;
    return randomPopUpNum;
  }
  // 全局计时器
  start(video: any, position: any, time: any, videoStatus: any) {
    const { onHookTipInfo } = videoStatus;
    console.log(window.pauseTimer, this.count);
    if (window.pauseTimer === null && this.count > 0) {
      this.count--;
      // 随机数
      let restTime = time - parseInt(position);
      let randonNum = Math.floor(Math.random() * (restTime - 0) + 0);
      window.pauseTimer = setInterval(() => {
        console.log("多少秒之后暂停弹窗", randonNum);
        console.log("剩余弹出次数", this.count);
        if (randonNum <= 0) {
          video.pause(); // 暂停视频
          this.pause(); // 清除计时器
          setTimeout(() => {
            alert(onHookTipInfo);
          }, 800);
        } else {
          randonNum--;
        }
      }, 1000);
    }
  }
  // 暂停视频
  pause() {
    clearInterval(window.pauseTimer);
    window.pauseTimer = null;
  }
  // 重置视频
  reset() {
    // 设置弹出次数
    this.count = this.getNumber();
  }
  /**
   * 记录视频进度
   * @param watchEventType 1:点击播放按钮;2:听课计时;3:听课结束(播放器当前位置到视频时长最大值）
   * @returns
   */
  async watch(watchEventType: number) {
    const { videoInfo } = store.getState();
    const {
      preventOnHookFlag,
      courseId,
      sectionId,
      watchStartTime = 0,
      videoDuration, // 总时长
      needRecord, // 是否需要记录
    } = videoInfo;
    if (!window.ccPlayerStatus || !needRecord) return;
    let video = window.ccPlayerStatus;
    let position = window.ccPlayerStatus.getPosition() || watchStartTime; // 获取视频进度
    // 调用随机弹窗的方法
    if (preventOnHookFlag === 2) {
      this.start(video, position, videoDuration, videoInfo);
    }
    let param = {
      courseId,
      sectionId,
      watchEventType,
      videoDuration,
      watchAt: position,
    };
    // 如果是看到最后，跳过一次请求
    if (watchEventType === 2 && position === video.getDuration()) {
      return;
    }
    if (watchEventType === 3) {
      // 如果是视频结束状态
      Object.assign(param, { totalWatchTime: position - watchStartTime });
    }
    const { data } = await querySaveWatchRecord(param);
    if (data === "notCurrentWatchVideo") {
      // 如果是多开的情况，强制暂停视频
      this.preventOopenMoreVideoFn(video);
    }
  }
  // 防多开
  async preventOopenMoreVideoFn(video: any) {
    video.pause();
  }
  // 初始化视频功能
  initVideo() {
    window.pauseTimer = null;
    window.onCCH5PlayerLoaded = () => {
      window.ccH5PlayerJsLoaded = true;
    };
    window.on_player_volumechange = (volume: any, vid: any) => {
      console.log("设置音量回调:  ", volume, vid);
    };
    // 播放器初始化完成
    // window.on_CCH5player_ready = (obj: any) => {
    //   videoControlInstance.watch(1);
    // };
    /**CC视频开始播放
     * @param {video}视频信息
     * @param {vid} vid
     * @return {void}
     */
    window.on_CCH5player_play = (video: any, vid: any) => {
      console.log("----play----");
      videoControlInstance.watch(1);
      clearInterval(window["playing"] as any);
      // 每30秒调用一次接口
      (window["playing"] as any) = setInterval(() => {
        videoControlInstance.watch(2);
      }, 30000);
    };
    /**CC视频暂停
     * @param {any}
     * @param {vid} vid
     * @return {void}
     */
    window.on_CCH5player_pause = (video: any, vid: string) => {
      console.log("----暂停----");
      videoControlInstance.watch(2);
      videoControlInstance.pause();
      // 清空30秒上传数据接口
      clearInterval(window["playing"]);
    };
    /**CC播放结束
     * @param {any}
     * @param {vid} vid
     * @return {void}
     */
    window.on_CCH5player_ended = (video: any, vid: string) => {
      console.log("----结束----");
      // 清空随机数计时器
      videoControlInstance.watch(3);
      videoControlInstance.pause();
      // 清空30秒上传数据接口
      clearInterval(window["playing"]);
    };
    /**
     *
     * @param mode 是否全屏 0为退出全屏 1为变成全屏
     * @param vid
     */
    // window.on_player_fullscreen = async (mode: 0 | 1, vid: string) => {
    //   if (mode === 1) {
    //     const ccVideoUrl = await videoControlInstance.getCCVideoUrlById(vid);
    //     await videoControlInstance.openVideo(ccVideoUrl as string);
    //   }
    // };
  }
}
export let videoControlInstance = new videoControlClass();
